module.exports = __webpack_public_path__ + "static/img/d-1.504c425.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/d-1.png
// module id = wvyM
// module chunks = 1